import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer(){
  return (
    <footer className="btw-footer">
      <div className="btw-footer-container">
        <hr className="btw-footer-divider" />
        <div className="btw-footer-inner">
          <div className="btw-footer-watermark">BETWEEN THE WALLS</div>
          <div className="btw-footer-row">
            <div className="btw-footer-left">© 2025 Between The Walls, Pune. </div>
            <div className="btw-footer-right">
              <Link to="/privacy-policy" className="btw-foot-link">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
